import { createSlice } from "@reduxjs/toolkit";

export const labelsSlice = createSlice({
  name: "labels",
  initialState: {
    labels: [],
    selectedLabels: [],
  },
  reducers: {
    setLabels: (state, action) => {
      state.labels = action.payload;
    },
    addLabel: (state, action) => {
      state.labels.push(action.payload);
    },
    updateLabel: (state, action) => {
      const index = state.labels.findIndex(label => label.id === action.payload.id);
      if (index !== -1) {
        state.labels[index] = action.payload;
      }
    },
    removeLabel: (state, action) => {
      state.labels = state.labels.filter(label => label.id !== action.payload);
    },
    clearLabels: (state) => {
      state.labels = [];
    },
    setSelectedLabels: (state, action) => {
      state.selectedLabels = action.payload;
    },
    clearSelectedLabels: (state) => {
      state.selectedLabels = [];
    },
  },
});

export const {
  setLabels,
  addLabel,
  updateLabel,
  removeLabel,
  clearLabels,
  setSelectedLabels,
  clearSelectedLabels,
} = labelsSlice.actions;

export default labelsSlice.reducer;
